import { render, staticRenderFns } from "./HomeFeedFixedProvider.vue?vue&type=template&id=3a99ad96&scoped=true"
import script from "./HomeFeedFixedProvider.vue?vue&type=script&lang=js"
export * from "./HomeFeedFixedProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a99ad96",
  null
  
)

export default component.exports